import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { List, Avatar, Menu, Dropdown } from "antd";
import perfil from "../../../assets/icons/iconPerfil.svg";
import pasta from "../../../assets/icons/iconPasta.svg";
import IcTresPontos from "../../../assets/icons/iconeTresPontinhos.svg";
import "./styles.scss";
import { Divider } from "rc-menu";
import { AutoComplete, Input } from "antd";
import { SearchOutlined } from "@mui/icons-material";
const ListUsuario = ({
  usuarios,
  showPerfil,
  handleSearch,
  handleEnterPress,
  setNomeUsuario,
  nomeUsuario,
  customFind,
}) => {
  const history = useHistory();

  const showIniciais = (nome) => {
    let nomecompleto = nome.replace(".", " ");
    var iniciais = nomecompleto.match(/\b(\w)/gi);
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase();
    return sobrenomes;
  };

  const customizarNomeUsuario = (nome) => {
    if (nome.length > 27) {
      var pastaName = nome.substring(0, Math.min(nome.length, 15));
      return pastaName + "...";
    }

    return nome;
  };
  const showMenu = (id) => {
    return (
      <div className="menu">
        <Menu>
          <Menu.Item
            key="1"
            onClick={() => {
              showPerfil(id);
              setUsuarioSelecionado(id);
            }}
          >
            <img src={perfil} alt="Perfil" className=" mr-1 ml-1" /> Ver perfil
          </Menu.Item>
        </Menu>
      </div>
    );
  };

  const compartilharPasta = () => {
    history.push("/galeria-midia/compartilhar");
  };

  const detalheUsuario = (id) => {
    showPerfil(id);
  };

  const handleClickUsuario = (e, item) => {
    e.preventDefault();
    showMenu(item.id);
  };

  const [usuarioSelecionado, setUsuarioSelecionado] = useState("");

  return (
    <div className="col-lg-4 col-md-4 col-sm-4">
      <div className="list-container">
        <span style={{ color: "#0042DD", fontSize: " 15px" }}>
          USUÁRIOS CADASTRADOS
        </span>
        <div className="row">
          <div className="pesquisar-autocomplete col-12 w-100 mt-4 mb-5">
            <AutoComplete
              dropdownClassName="dropdownload-pesquisar-header"
              className="pesquisar-header"
              backfill={true}
              autoClearSearchValue={true}
              value={nomeUsuario}
              onChange={(e) => setNomeUsuario(e)}
            >
              <Input
                className="pesquisa-input"
                onPressEnter={(e) => handleEnterPress(e.target.value)}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </AutoComplete>
            <SearchOutlined
              style={{ cursor: "pointer" }}
              onClick={customFind}
              className="pesquisar-icon-search header-icons"
            />
          </div>
        </div>
      </div>
      <div className="list-container mt-3">
        <List
          className="list-usuariosBorder "
          size="small"
          dataSource={usuarios}
          renderItem={(item) => {
            return (
              <List.Item
                className={
                  usuarioSelecionado == item.id
                    ? "list-item-usuarios usuarioSelecionado"
                    : "list-item-usuarios"
                }
              >
                <Dropdown.Button
                  trigger={["click"]}
                  style={{ padding: "10px 0px" }}
                  className="svgIcon"
                  overlay={() => showMenu(item.id)}
                  placement="bottomLeft"
                  icon={<img src={IcTresPontos} alt="Ícone" />}
                >
                  <Avatar
                    className={
                      usuarioSelecionado == item.id
                        ? " avatarUsuarioSelecionado"
                        : "avatarUsuario"
                    }
                    onClick={() => {
                      showPerfil(item.id);
                      setUsuarioSelecionado(item.id);
                    }}
                  >
                    {showIniciais(item.login)}
                  </Avatar>
                  <span
                    onContextMenu={(e) => e.preventDefault()}
                    className={
                      usuarioSelecionado == item.id
                        ? " usuario-nomeSelecionado"
                        : "usuario-nomes"
                    }
                    onClick={() => {
                      showPerfil(item.id);
                      setUsuarioSelecionado(item.id);
                    }}
                  >
                    <div>
                      <span>{customizarNomeUsuario(item.login)}</span>
                    </div>
                  </span>
                </Dropdown.Button>
              </List.Item>
            );
          }}
        />
      </div>
    </div>
  );
};

export default ListUsuario;
